/**
 * Work order party roles — frontend config (epic #763, #768)
 *
 * Mirrors the Staff API role catalogue (services/staff-api/src/lib/
 * work-order-party-roles.ts). Keep the two in sync.
 */

export const WORK_ORDER_PARTY_ROLES = [
  'orderer',
  'billing_party',
  'primary_contact',
  'dropoff_person',
  'pickup_person',
  'insurance_company',
  'leasing_company',
  'approval_recipient',
] as const;

export type WorkOrderPartyRole = (typeof WORK_ORDER_PARTY_ROLES)[number];
export type PartyType = 'person' | 'company';

const ROLE_PARTY_TYPES: Record<WorkOrderPartyRole, readonly PartyType[]> = {
  orderer: ['person', 'company'],
  billing_party: ['person', 'company'],
  primary_contact: ['person'],
  dropoff_person: ['person'],
  pickup_person: ['person'],
  insurance_company: ['company'],
  leasing_company: ['company'],
  approval_recipient: ['person'],
};

export const REQUIRED_WORK_ORDER_PARTY_ROLES: readonly WorkOrderPartyRole[] = ['orderer'];

export function allowedPartyTypesForRole(role: WorkOrderPartyRole): readonly PartyType[] {
  return ROLE_PARTY_TYPES[role];
}

export function isRequiredPartyRole(role: WorkOrderPartyRole): boolean {
  return REQUIRED_WORK_ORDER_PARTY_ROLES.includes(role);
}
